import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loaderVisible: false,
  snackbar: {
    open: false,
    message: "",
    color: "",
    vertical: "bottom",
    horizontal: "left",
  },
  dialog: {
    open: false,
    outSideClickDismiss: true,
    title: "",
    subTitle: "",
    negativeAction: "",
    positiveAction: "",
    positiveReq: false,
    iconReq: false,
    iconContent: "",
    cancelExtra: false,
    negativeReq: false,
    gui: "",
  },
  notification: {},
};

const snpGlobalUiSlice = createSlice({
  name: "snpGlobalUi",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.loaderVisible = true;
    },
    hideLoader: (state) => {
      state.loaderVisible = false;
    },

    showSnackbar: (state, { payload }) => {
      state.snackbar = { ...payload, open: true };
    },
    hideSnackbar: (state) => {
      state.snackbar.open = false;
    },

    showDialog: (state, { payload }) => {
      state.dialog = { ...payload, open: true };
    },
    hideDialog: (state) => {
      state.dialog.open = false;
    },

    setNotification: (state, { payload }) => {
      state.notification = payload;
    },
    clearNotification: (state) => {
      state.notification = {};
    },
  },
});

export const {
  showLoader,
  hideLoader,
  showSnackbar,
  hideSnackbar,
  showDialog,
  hideDialog,
  setNotification,
  clearNotification,
} = snpGlobalUiSlice.actions;

export const snpGlobalUiReducer = snpGlobalUiSlice.reducer;
